import { Risk, Value } from "../units";
import { Systolic } from "./systolic";
import { Diastolic } from "./diastolic";

export function riskFor({
  systolic,
  diastolic,
  age,
}: {
  systolic: Value<"mmHg">;
  diastolic: Value<"mmHg">;
  age: number;
}): Risk {
  const ranges = {
    systolic: Systolic.rangesFor({ age }),
    diastolic: Diastolic.rangesFor({ age }),
  };

  const risk = {
    systolic: ranges.systolic.findRisk(systolic),
    diastolic: ranges.diastolic.findRisk(diastolic),
  };

  return risk.systolic > risk.diastolic ? risk.systolic : risk.diastolic;
}

export const BrachialPressure = {
  riskFor,
};
